(function () {
  'use strict';

  angular.module('ringbaPortal').directive('routeBodyCssClass', routeBodyCssClass);

  function routeBodyCssClass($transitions) {
    return {
      restrict: 'A',
      scope: {},
      link: function (scope, elem) {
        const killTransitionHook = $transitions.onSuccess({}, function (trans) {
          const toState = trans.to(),
            fromState = trans.from();
          const fromClassnames = angular.isDefined(fromState.data) && angular.isDefined(fromState.data.cssClassNames) ? fromState.data.cssClassNames : null;
          let toClassnames = angular.isDefined(toState.data) && angular.isDefined(toState.data.cssClassNames) ? toState.data.cssClassNames : null;
          
          try {
            const resolvedCssClassNames = trans.injector().get('cssClassNames');
            if (resolvedCssClassNames != null) { 
              toClassnames = resolvedCssClassNames;
            }
          } catch {
            //
          }

          // don't do anything if they are the same
          if (fromClassnames != toClassnames) {
            if (fromClassnames) {
              elem.removeClass(fromClassnames);
            }

            if (toClassnames) {
              elem.addClass(toClassnames);
            }
          }
        });

        elem.on('$destroy', function() {
          killTransitionHook();
        });
      }
    };
  }
}());
